/* eslint-disable max-lines-per-function */
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { useSelector } from 'react-redux'
import ComboDropdownKhoaThi from '../../components/form/ComboDropdownKhoaThi'
import { setDonViDangKyDuThiId } from '../../store/reducer/donViDangKyDuThi'
import { setHeDaoTaoId } from '../../store/reducer/heDaoTao'
import { setHinhThucDaoTaoId } from '../../store/reducer/hinhThucDaoTao'
import store from '../../store/store'

const VanBangSearcher = (props) => {
  const {
    donViDangKyDuThiId,
    donViDangKyDuThis,
    heDaoTaoId,
    hinhThucDaoTaoId,
    heDaoTaos,
    hinhThucDaoTaos,
  } = useSelector((item) => {
    const { khoaThi, donViDangKyDuThi, heDaoTao, hinhThucDaoTao } = item
    return {
      khoaThiId: khoaThi.id,
      khoaThis: khoaThi.datas.map((kt) => {
        return { ...kt }
      }),
      donViDangKyDuThiId: donViDangKyDuThi.id,
      donViDangKyDuThis: donViDangKyDuThi.datas.map((kt) => {
        return { ...kt }
      }),
      heDaoTaoId: heDaoTao.id,
      heDaoTaos: heDaoTao.datas.map((kt) => {
        return { ...kt }
      }),
      hinhThucDaoTaoId: hinhThucDaoTao.id,
      hinhThucDaoTaos: hinhThucDaoTao.datas.map((kt) => {
        return { ...kt }
      }),
    }
  })
  const user = useSelector((item) => item.user.info)

  const { name, setName, disable } = props
  return (
    <div className="flex vanbang-seacher-cotainer">
      <span
        className="p-input-icon-right mr-2 mb-2"
        style={disable && disable.find((item) => item === 'name') ? { display: 'none' } : []}
      >
        <InputText
          value={name}
          type="text"
          placeholder="Tìm theo tên, số hiệu,..."
          onChange={(e) => setName && setName(e.target.value)}
        />
        <i className="pi pi-search" />
      </span>
      <ComboDropdownKhoaThi {...props} />
      {!user.truongId && (
        <>
          <Dropdown
            tooltip="Trường tốt nghiệp"
            tooltipOptions={{ position: 'top' }}
            className="mr-2 mb-2"
            optionLabel="name"
            optionValue="id"
            options={[{ id: 0, name: 'Trường tốt nghiệp' }, ...donViDangKyDuThis]}
            value={donViDangKyDuThiId}
            onChange={(e) => {
              store.dispatch(setDonViDangKyDuThiId(e.value))
            }}
            filter
            filterBy="name"
          />
          <Dropdown
            tooltip="Hệ đào tạo"
            tooltipOptions={{ position: 'top' }}
            style={
              disable && disable.find((item) => item === 'heDaoTao') ? { display: 'none' } : []
            }
            className="mr-2 mb-2"
            optionLabel="name"
            optionValue="id"
            options={[{ id: 0, name: 'Hệ đào tạo' }, ...heDaoTaos]}
            value={heDaoTaoId}
            onChange={(e) => {
              store.dispatch(setHeDaoTaoId(e.value))
            }}
            filter
            filterBy="name"
          />
          <Dropdown
            tooltip="Hình thức đào tạo"
            tooltipOptions={{ position: 'top' }}
            style={
              disable && disable.find((item) => item === 'hinhThucDaoTao')
                ? { display: 'none' }
                : []
            }
            className="mr-2 mb-2"
            optionLabel="name"
            optionValue="id"
            options={[{ id: 0, name: 'Hình thức đào tạo' }, ...hinhThucDaoTaos]}
            value={hinhThucDaoTaoId}
            onChange={(e) => {
              store.dispatch(setHinhThucDaoTaoId(e.value))
            }}
            filter
            filterBy="name"
          />
        </>
      )}
    </div>
  )
}

export default VanBangSearcher
